import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChannelListLocationCell } from './channel-list-location.cell';
import { ChannelListLocationHeader } from './channel-list-location.header';

export const ChannelListLocationColumn: IdentifiedColumnDef<
  GatewayChannelWithChargePointInfoModel,
  GatewayChannelWithChargePointInfoModel['location']
> = {
  enableSorting: false,
  header: ChannelListLocationHeader,
  cell: ChannelListLocationCell,
};
